if ($('.js-data-table-memberships-multiple-subscriptions').length) {
    function returnDataTableMembershipsSubscriptionsOptions(dataArray) {
        return {
            data: dataArray,
            order: [],
            columns: [
                {
                    data: 'checkbox',
                    render: function (data, type, row, meta) {
                        const isDisabled =
                            row.Status === 'Active' ||
                            row.Status === 'Active (Owned)';
                        return `<div class="df fcc w-m-48 h-m-48">
                                <input ${
                                    isDisabled && 'disabled'
                                } class="js-dt-checkbox" type="checkbox" name="${row.Seat.toString()}" id="${row.Seat.toString()}" data-status="${row.Status.toLowerCase()}" data-email="${row.Recipient.toLowerCase()}"/>
                                <label for="${row.Seat.toString()}" class="cardCheckbox"/>    
                        </div>`;
                    },
                },
                {
                    data: 'Seat',
                    render: function (data, type, row, meta) {
                        return `<div class="pl-m-8">${row.Seat}</div>`;
                    },
                },
                {
                    data: 'Status',
                    render: function (data, type, row, meta) {
                        let status = row.Status;
                        let color;

                        switch (status) {
                            case 'Unclaimed':
                                color = 'border-color-blue c-blue';
                                break;
                            case 'Active':
                                color = 'border-color-green-dark c-green-dark';
                                break;
                            case 'Active (Owned)':
                                color = 'border-color-green-dark c-green-dark';
                                break;
                            case 'Pending':
                                color = 'border-color-gray-9 c-gray-9';
                                break;
                            case 'Expired':
                                color = 'border-color-red c-alert';
                                break;
                            default:
                                color = 'border-color-blue c-blue';
                        }
                        return `<div class="df jc-m-e fw"><div class="df w-fc fz-12-16 fw-600 px-8 py-5 border-blue border-radius-20 ${color}">${row.Status}</div></div>`;
                    },
                },
                { data: 'Recipient' },
                {
                    data: 'Date',
                    type: 'date',
                    render: function (data, type, row, meta) {
                        /* let formattedDate = moment(data).format('ll');
                        return formattedDate; */
                        return `<span class="db-m fw-m ta-m-l ${
                            row.Status === 'Expired' ? 'c-alert' : ''
                        }">${
                            row.Date !== false &&
                            row.Date !== '' &&
                            row.Date !== null
                                ? row.Date
                                : '&mdash;'
                        }</span>`;
                    },
                },
                {
                    data: 'Actions',
                    render: function (data, type, row, meta) {
                        const api = new $.fn.dataTable.Api(meta.settings);
                        // 1. If at least one has "Active (Owned)"
                        const hasActiveOwned = api
                            .data()
                            .toArray()
                            .some((item) => item.Status === 'Active (Owned)');

                        // 2. Check if it's the first "Unclaimed" row
                        let isFirstUnclaimed = false;
                        if (
                            !hasActiveOwned &&
                            row.Status === 'Unclaimed' &&
                            row.Status !== 'Pending'
                        ) {
                            const dataArr = api.data().toArray();
                            const firstUnclaimedIdx = dataArr.findIndex(
                                (item) => item.Status === 'Unclaimed'
                            );
                            isFirstUnclaimed = meta.row === firstUnclaimedIdx;
                        }

                        if (isFirstUnclaimed) {
                            return `<div class="df fec gap-12 gap-m-16">
                                        <button onclick="handleTriggerInvitationEvent('claim', '${
                                            row.Recipient
                                        }')" data-open="mdl-memberships-confirm-activation" type="button" class="bg-c-transparent ws-nw p-0 td-u td-hover-none fw-700">Claim</button>
                                        <div class="w-1 h-20 bg-c-gray-4 last-child-hidden"></div>
                                        ${row.Actions.map(
                                            (item) =>
                                                `<button data-open="mdl-memberships-invitation" onclick="handleTriggerInvitationEvent('${item}', '${row.Recipient}')" type="button" class="bg-c-transparent ws-nw p-0 td-u td-hover-none fw-700">${item}</button><div class="w-1 h-20 bg-c-gray-4 last-child-hidden"></div>`
                                        ).join('')}
                                    </div>`;
                        }

                        if (row.Status !== 'Pending') {
                            return `<div class="df fec gap-12">
                                        ${row.Actions.map(
                                            (item) =>
                                                `<button data-open=${
                                                    item === 'Invite' &&
                                                    'mdl-memberships-invitation'
                                                }  onclick="handleTriggerInvitationEvent('${item}', '${
                                                    row.Recipient
                                                }')" type="button" class="bg-c-transparent ws-nw p-0 td-u td-hover-none fw-700">${item}</button><div class="w-1 h-20 bg-c-gray-4 last-child-hidden"></div>`
                                        ).join('')}
                                    </div>`;
                        } else {
                            return `<div class="fec fw dc-m pos-relative">
                <button class="dn-m bg-c-transparent px-4 py-1 active-color-blue" data-drop="${row.Seat.toString()}-dropdown">
                    <svg class="icon w-24 h-24">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/svg-sprite.svg#icon-triple-dots-24"></use>
                    </svg>
                </button>
                <div id="${row.Seat.toString()}-dropdown" class="js-dropdown dropdown under left w-190 py-m-0 fw-m border-m-none box-shadow-m-none df-m pos-m-static jc-m-e ai-m-c flex-direction-m-row gap-m-16">
                    ${row.Actions.map((item) => {
                        return `<button data-open=${
                            (item === 'Edit' &&
                                'mdl-memberships-edit-invitation') ||
                            (item === 'Cancel' &&
                                'mdl-memberships-confirm-cancellation')
                        } onclick="handleTriggerInvitationEvent('${item}', '${
                            row.Recipient
                        }')" type="button" class="bg-c-transparent ws-nw px-16 py-12 p-m-0 td-m-u td-hover-none fw-400 fw-m-700 ta-l w-m-fit-content">${item} <span class="dn-m">Invitation</span></button>
                        <div class="dn db-m w-1 h-20 bg-c-gray-4 last-child-hidden"></div>`;
                    }).join('')}
                </div>
            </div>`;
                        }
                    },
                },
            ],
            columnDefs: [
                {
                    target: 0,
                    orderable: false,
                },
                {
                    target: 1,
                    orderable: false,
                },
                {
                    target: 2,
                    orderable: false,
                },
                {
                    target: 3,
                    orderable: false,
                },
                {
                    target: 4,
                    orderable: false,
                },
                {
                    target: 5,
                    orderable: false,
                },
            ],
            scrollX: true,
            fixedColumns: {
                leftColumns: 1,
            },
            search: {
                caseInsensitive: true,
            },
            // bDestroy - enable rerender table with new data array by event.
            bDestroy: true,
            pageLength: 15,
            layout: {
                topStart: null,
                // topStart: {
                //     info: {
                //         text: 'EVENTS: _TOTAL_',
                //         empty: 'EVENTS: _TOTAL_',
                //         search: '',
                //     },
                // },
                topEnd: null,
                bottomStart: null,
                bottomEnd: null,
            },
            createdRow: function (row, data, dataIndex) {
                /* this is for opening new page with link */
                // $(row).each(function (index) {
                //     $(this)
                //         .attr('data-href', data.Link)
                //         .addClass('js-dt-row-clickable');
                // });
            },
            /* stable version with Date th problem */
            initComplete: function () {
                // displayLargeDataTooltip();
                addCellLabel();

                setInfoResultsIntoMobileContainer(
                    this.api().page.info().recordsDisplay
                );
                // setResetAllControlsState();

                setTimeout(() => {
                    $('.js-datatable-loader').removeClass('active');
                    $('.js-datatable-wrap').addClass('active');

                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                    }, 0);
                }, 150);
            },
        };
    }

    let tableMembershipsSubscriptions = $(
        '.js-data-table-memberships-multiple-subscriptions'
    ).DataTable(
        returnDataTableMembershipsSubscriptionsOptions(
            membershipsManageMultipleSubscriptionsArray
        )
    );

    fireFunctionOnDataTablesNativeEvents(tableMembershipsSubscriptions);

    customSearch(tableMembershipsSubscriptions);

    /* HELPER FUNCTIONS */
    function showSelectedCheckboxesCount() {
        const allCheckboxes = $('.js-dt-checkbox:not(:disabled)');
        const selectedCheckboxes = allCheckboxes.filter(':checked');
        const controlsPanel = $('.js-bulk-controls-panel');
        const checkedQuantityElement = $('.js-checked-quantity');

        /* check if some of checked inputs have "unclaimed" or "pending" status */
        const someUnclaimedOrPending = selectedCheckboxes
            .map((_, el) => $(el).data('status'))
            .get()
            .some((status) => status === 'unclaimed' || status === 'pending');

        /* show quantity only if some of checked inputs have "unclaimed" or "pending" status */
        if (selectedCheckboxes.length >= 1 && someUnclaimedOrPending) {
            checkedQuantityElement.text(selectedCheckboxes.length);
            controlsPanel.addClass('active');
        } else {
            controlsPanel.removeClass('active');
        }
    }

    runIfElementExist(showSelectedCheckboxesCount, '.js-bulk-controls-panel');

    function showAppropriateControls() {
        const selectedCheckboxes = $('.js-dt-checkbox:checked');
        const unclaimedControls = $('.js-unclaimed-controls');
        const pendingControls = $('.js-pending-controls');
        const mixedControls = $('.js-mixed-controls');

        if (selectedCheckboxes.length === 0) {
            unclaimedControls.removeClass('active');
            pendingControls.removeClass('active');
            mixedControls.removeClass('active');
        }

        const allUnclaimed = selectedCheckboxes
            .map((_, el) => $(el).data('status'))
            .get()
            .every((status) => status === 'unclaimed');

        const allPending = selectedCheckboxes
            .map((_, el) => $(el).data('status'))
            .get()
            .every((status) => status === 'pending');

        if (allUnclaimed) {
            unclaimedControls.addClass('active');
            pendingControls.removeClass('active');
            mixedControls.removeClass('active');
        } else if (allPending) {
            unclaimedControls.removeClass('active');
            pendingControls.addClass('active');
            mixedControls.removeClass('active');
        } else {
            unclaimedControls.removeClass('active');
            pendingControls.removeClass('active');
            mixedControls.addClass('active');
        }
    }

    function handleDeselectAll() {
        const allCheckboxes = $('.js-dt-checkbox:not(:disabled)');
        allCheckboxes.prop('checked', false);

        handleCheckboxChange();
    }

    $(document).on('click', '.js-deselect-all-btn', function () {
        handleDeselectAll();
    });

    function handleCheckboxChange() {
        const allCheckboxes = $('.js-dt-checkbox:not(:disabled)');
        const masterCheckboxes = $('.js-dt-checkbox-all');

        if ($(this).hasClass('js-dt-checkbox-all')) {
            const isChecked = $(this).prop('checked');
            allCheckboxes.prop('checked', isChecked);
            masterCheckboxes.prop('checked', isChecked);
            // Remove partlyChecked when master checkbox is clicked
            masterCheckboxes.removeClass('partlyChecked');
        } else {
            const checkedCount = allCheckboxes.filter(':checked').length;
            const totalCount = allCheckboxes.length;

            if (checkedCount === 0) {
                // No checkboxes checked
                masterCheckboxes.prop('checked', false);
                masterCheckboxes.removeClass('partlyChecked');
            } else if (checkedCount === totalCount) {
                // All checkboxes checked
                masterCheckboxes.prop('checked', true);
                masterCheckboxes.removeClass('partlyChecked');
            } else {
                // Some checkboxes checked (partly checked state)
                masterCheckboxes.prop('checked', true);
                masterCheckboxes.addClass('partlyChecked');
            }
        }

        showAppropriateControls();
        showSelectedCheckboxesCount();
    }

    $(document).on(
        'change',
        '.js-dt-checkbox-all, .js-dt-checkbox',
        handleCheckboxChange
    );

    function handleSetBulkCancellationQuantity() {
        const selectedCheckboxes = $(
            '.js-dt-checkbox[data-status="pending"]:checked'
        );
        const quantityElement = $('.js-bulk-cancellation-quantity');

        if (selectedCheckboxes.length > 0) {
            quantityElement.text(selectedCheckboxes.length);
        } else {
            quantityElement.text('0');
        }
    }

    $(document).on('click', '.js-bulk-cancellation-popup-btn', function () {
        handleSetBulkCancellationQuantity();
        handleGetPendingBulkInvitationsEmails('pending');
        handleTriggerInvitationEvent(
            'cancelbulk',
            handleGetPendingBulkInvitationsEmails('pending')
        );
    });

    function handleGetPendingBulkInvitationsEmails(event) {
        const selectedCheckboxes = $(
            `.js-dt-checkbox[data-status="${event}"]:checked`
        );
        const emailsArray = [];

        selectedCheckboxes.each(function () {
            const email = $(this).data('email');
            emailsArray.push(email);
        });

        return emailsArray;
    }

    $(document).on('click', '.js-bulk-resend-btn', function () {
        handleGetPendingBulkInvitationsEmails('pending');
        handleTriggerInvitationEvent(
            'resendbulk',
            handleGetPendingBulkInvitationsEmails('pending')
        );
    });

    /* MANAGE SUBSCRIPTIONS EVENTS */
    function handleTriggerInvitationEvent(eventType, recipient) {
        const event = new CustomEvent(eventType.toLowerCase(), {
            detail: {
                recipient: recipient,
            },
            bubbles: true,
            cancelable: true,
        });

        document.dispatchEvent(event);

        if (eventType.toLowerCase() === 'edit') {
            $('.js-memberships-edit-invitation-field').val(recipient);
        }
    }

    // Example usage of the custom events
    // document.addEventListener('cancelbulk', function (event) {
    //     console.log(event, event.detail.recipient);
    // });

    /* /HELPER FUNCTIONS */
}
